module.exports = __webpack_public_path__ + "img/calendar.eeb4f930.svg";